const storage = window.sessionStorage;

export function storeLogin({ user, token }) {
    storage.setItem('user', user);
    storage.setItem('token', token);
}

export function storeSecondToken(token) {
  storage.setItem('secondToken', token);
}

export function fetchLogin() {
    const user = storage.getItem('user');
    const token = storage.getItem('token');
    const secondToken = storage.getItem('secondToken');

    return {
        user: user,
        token: token,
        secondToken: secondToken
    }
}

export function clearLogin() {
    storage.removeItem('token');
    if(storage.getItem('secondToken')){
      storage.setItem('token', storage.getItem('secondToken'));
      storage.removeItem('secondToken');
    }
    else {
      storage.removeItem('user');
    }
}

export function clearAll() {
    clearLogin();
}
